import { get } from "lodash";
import { isLoaded } from "react-redux-firebase";

export function isCharityFirebasePathLoaded(
  firebase: { data?: Record<string, unknown> },
  charityId: string,
  subPath: string
): boolean {
  if (!charityId) {
    return false;
  }
  const firebasePath = subPath.split("/").join(".");
  return isLoaded(get(firebase, `data.${charityId}.${firebasePath}`));
}

export type SetupCardKey =
  | "organization"
  | "givespark"
  | "email"
  | "branding"
  | "mms";

export const isOrganizationSetupComplete = (
  organizationData: { status?: string } | null | undefined,
  dataLoaded: boolean
): boolean => {
  if (!dataLoaded || !organizationData) {
    return false;
  }
  return (
    organizationData.status === "completed" ||
    organizationData.status === "submitted"
  );
};

export const hasWebsitePublished = (
  brandSetup: { publishedAt?: number } | null | undefined
): boolean => Boolean(brandSetup?.publishedAt);

const ORG_LOCK_TOOLTIPS: Record<
  Exclude<SetupCardKey, "organization">,
  string
> = {
  givespark:
    "Finish setting up your organization so we can start setting up GiveSpark",
  email:
    "Finish setting up your organization so we can start setting up Email",
  branding:
    "Finish setting up your organization so we can start setting up Branding",
  mms:
    "Finish setting up your organization and publish your website so we can start setting up MMS",
};

const MMS_PUBLISH_TOOLTIP =
  "Publish your ViewSpark website at least once so we can start setting up MMS";

export const getSetupCardLockState = (
  key: SetupCardKey,
  orgComplete: boolean,
  published: boolean
): { locked: boolean; tooltip?: string } => {
  if (key === "organization") {
    return { locked: false };
  }

  if (!orgComplete) {
    return { locked: true, tooltip: ORG_LOCK_TOOLTIPS[key] };
  }

  if (key === "mms" && !published) {
    return { locked: true, tooltip: MMS_PUBLISH_TOOLTIP };
  }

  return { locked: false };
};

export const DEFAULT_MAX_VIDEO_LENGTH_SECONDS = 90;

export const formatDurationMinutesSeconds = (totalSeconds: number): string => {
  const rounded = Math.max(0, Math.round(totalSeconds));
  const minutes = Math.floor(rounded / 60);
  const seconds = rounded % 60;
  if (minutes === 0) {
    return `${seconds} sec`;
  }
  if (seconds === 0) {
    return `${minutes} min`;
  }
  return `${minutes} min ${seconds} sec`;
};
